<template>
  <div id="app">
    <b-navbar toggleable="md" class="navbar navbar-dark" v-bind:style="$route.name == 'ViewMeeting' ? {maxHeight:'0.2rem'} : {maxHeight:'10rem'}">
      <template v-if="$route.name != 'ViewMeeting'">
        <router-link :to="user ? '/MyMeetings': '/'">
          <b-navbar-brand >
            <img v-if="$route.name!='ViewMeeting'" src="@/assets/logoText.png" key="a">
            <img v-if="$route.name=='ViewMeeting'" src="@/assets/logo.png" key="b">
          </b-navbar-brand>
          <router-link :to="'/MyMeetings'" v-if="$route.name == 'ViewMeeting'" style="color:white; font-weight:450">
            My Meetings
          </router-link>&nbsp;
          <b-badge variant="light">{{envTitle}}</b-badge>
        </router-link>

        <b-navbar-nav class="ml-auto">
         <b-nav-item v-if="!user" href="#" :Xto="'/login'" @click="modalShowSignIn = true">Login</b-nav-item>
         <b-nav-item-dropdown right v-if="user" data-hj-suppress>
          <template slot="button-content">
           {{userName}}
          </template>
          <b-dropdown-text style="font-size:0.9rem; color: #262626">
            <b>Plan:</b> <span style="color: var(--primaryColor1);font-weight:500"> {{userPlan}}</span>
          </b-dropdown-text>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" @click="signOut3()">Log out</b-dropdown-item>
        </b-nav-item-dropdown>
        </b-navbar-nav>
    </template>
    </b-navbar>

    <div id="content">
      <router-view v-bind:user="user" v-on:planChanged="userPlan = $event" @login="loginGoogle5" :key="$route.fullPath"/>
    </div>
    <div>
      <div v-if="$route.name != 'ViewMeeting'" class="footer">©2020 Web Automatic Ltd All Rights Reserved &nbsp;&nbsp;&nbsp;
      <router-link to="/tos">Terms of Service</router-link> &nbsp;&nbsp;&nbsp;
      <router-link to="/privacypolicy">Privacy Policy</router-link>
      </div>
    </div>
    <b-modal hide-footer size="lg" v-model="modalShowSignIn" title="Welcome back to Moogenda!">
     <p class="modalMessage">Sign in with Google to access your account.</p>
      <div style="Xmin-height:20rem;display:flex;flex-direction: column;align-items:center;justify-content: center">
        <b-btn id="SignUpGoogle" variant="link" @click="modalShowSignIn=false;loginGoogle5()"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn>
        <br><br>
     </div>
     </b-modal>
  </div>
</template>

<script>
import {firebase, router, db} from './main'
export default {
  name: 'App',
  props: ['user'],
  data () {
    return {
      userPlan: '',
      modalShowSignIn: false
    }},
  methods: {
    loginGoogle5 (redirectStripe) {
      this.$getGapiClient().then(gapi => {
        gapi.auth2.getAuthInstance().signIn().then( (googleUser) => {
          var credential = firebase.auth.GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token)
          firebase.auth().signInWithCredential(credential).catch(function(error) {
            console.log(error)
          }).then((result) =>{

          if (redirectStripe) {
            this.stripePayment(result)
            } else {
              router.replace('/MyMeetings')
            }
          })
        })
      })
    },
    stripePayment(result){
      var stripeKey = process.env.VUE_APP_STRIPE_KEY
      var stripePersonalPlanId = process.env.VUE_APP_STRIPE_PERSONAL_ID
      var stripe = Stripe(stripeKey)
      setTimeout( () => {
        var port = window.location.port ? ':' + window.location.port : ''
        stripe.redirectToCheckout({
          items: [{plan: stripePersonalPlanId, quantity: 1}],
          successUrl: window.location.protocol + '//' + window.location.hostname + port + '/#/MyMeetings?WelcomePersonal=y',
          cancelUrl: window.location.protocol + '//' + window.location.hostname +  port + '/home',
          customerEmail: result.user.email
        }).then(function (result) {
          if (result.error) {
            console.log('Unable to process Payment')
            console.log(result.error)
          }
        })
      },5000)
    } ,
    signOut3 () {
      this.$logout().then(()=>{
        firebase.auth().signOut().then(function () {
          router.replace('login')
        }).catch(function (error) {
          console.log(error)
        })
      })
    },
    // loginGoogle () {
    //   alert('loginGoogle()')
    //   var provider = new firebase.auth.GoogleAuthProvider()
    //   firebase.auth().signInWithPopup(provider).then(function (result) {
    //     debugger
    //     var token = result.credential.accessToken;
    //     router.replace('/MyMeetings')
    //   })
    //   this.modalShowSignIn = false
    // },
  },
  computed: {
    envTitle () {
      return process.env.VUE_APP_ENV_TITLE
    },
    userName () {
      return this.user ? this.user.displayName : 'Not logged in'
    }
  },
  watch: {
    user () {
      console.log("watching user")
      if (this.user != undefined) {
        var accountDocRef = db.collection('Accounts').doc(this.user.email)
        var vm = this
        accountDocRef.get().then( (doc) => {
          if (doc.data().plan != undefined) {
            vm.userPlan = doc.data().plan
          } else {
            vm.userPlan  = 'Free'
          }
        })
      }
    }
  }
}
</script>

<style>
  /* Fonts */
  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:700');
  @import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
@import url('https://fonts.googleapis.com/css?family=B612+Mono|Courier+Prime|Roboto+Mono|Share+Tech+Mono&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap');
  :root {
  --primaryColor1: #52B2CF;
  --lightGray: #F7F7F6;
  }
  body{color:#262626; font-size: 16px;  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';}
  .contentTitle {font-size:1.5rem; font-weight:bold;}

h2 {font-size: 1.2rem}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  }

  .bg-info { background-color:pink;}

  /* Nav bar */
  .navbar-default {
    background-color: #F8F8F8;
    border-color: #E7E7E7;
  }
  .navbar{
       padding-top:2px !important; padding-bottom:2px !important; background-color:var(--primaryColor1)
  }
  .navbar-brand{margin-left:.4rem}

    /* Modal Dialgog*/
  .modal-header {background-color: var(--primaryColor1); color:white}
  button.close {color: white}

  /* Headers */
  h1 {font-size: 2rem}
  h2 {font-size: 1.2rem !important}
  .bigTitle{font-size:3.6rem;font-family: Source Sans Pro;color:#262626;line-height: 3.6rem;text-align: left;font-weight:600;max-width: 22rem;margin:.5rem 0;margin-Top:0rem;letter-spacing: 0.rem}

  /* Links */
  .contentLink {color:var(--primaryColor1) !important}
  .contentLink:hover {text-decoration: underline}

  /* Section Label */
  .sectionLabel {color: #808080; font-size: 1.2rem}

  #content {flex:1}

  /*  Bootstrap Button Styles */
  .btn-primary {background-color: var(--primaryColor1) !important; border-color: var(--primaryColor1) !important}
  .btn-primary:hover .btn-primary:focus {background-color: var(--primaryColor1); border-color: var(--primaryColor1)}
  .btn-outline-primary {border-color: var(--primaryColor1); color: var(--primaryColor1)}
  .btn-outline-primary:hover {border-color: var(--primaryColor1); color:white; background-color:var(--primaryColor1)}

  /*  .btn-secondary {background-color:white; border-color:var(--primaryColor1);color: var(--primaryColor1)}*/
  .btn-success {background-color:var(--primaryColor1); border-color:var(--primaryColor1)}

  /* Footer */
  .footer{font-size:0.8rem;margin-top: .4rem;text-align: center;height:3rem;line-height:3rem}
  .terms {font-size:0.8rem;xwidth: 16rem;margin-top: .4rem;}

  /* Temporary Borders */
    [class*="col-"]{Xborder:1px red dashed}
    .row{Xborder:2px green dashed}

  /* Content Colours */
.No0 { background-color: #ef6f6c !important}
.No1 { background-color: #e56399 !important}
.No2 { background-color: #588b8b !important}
.No3 { background-color: #8C56B5 !important}
.No4 {background-color: #3F7CAC !important}
.No5 {background-color: #A37B73 !important}
.No6 {background-color: #66CED6 !important}
.No7 {background-color: #8797B2 !important}
.No8 {background-color: #588157 !important}
.No9 {background-color: #B36A5E !important}
.No10 {background-color: #686868 !important}
.No11 {background-color: #C2AFF0 !important}
.No12 {background-color: #FFB20F !important}
.No13 {background-color: #E4572E !important}
.No14 {background-color: #4E937A !important}
.No15 {background-color: #B4656F !important}
.No16 {background-color: #DBB4AD !important}
.No17 {background-color: #61E786 !important}
.No18 {background-color: #ECCE8E !important}
.No19 {background-color: #493657 !important}

.bo0 { border-left-color: #ef6f6c !important}
.bo1 { border-left-color: #e56399 !important}
.bo2 { border-left-color: #588b8b !important}
.bo3 { border-left-color: #8C56B5 !important}

  /* .itemTime.i0{color: #ef6f6c} */
  .i0{color: #ef6f6c}
  .i1{color: #e56399}
  .i2{color: #588b8b}
  .i3{color: #8C56B5}
  .i4{color: #3F7CAC}
  .i5{color: #A37B73}
  .i6{color: #66CED6}
  .i7{color: #8797B2}
  .i8{color: #588157}
  .i9{color: #B36A5E}
  .i10{color: #686868}
  .i11{color: #C2AFF0}
  .i12{color: #FFB20F}
  .i13{color: #E4572E}
  .i14{color: #4E937A}
  .i15{color: #B4656F}
  .i16{color: #DBB4AD}
  i17{color: #61E786}
  .i18{color: #ECCE8E}
  .i19{color: #493657}
</style>
